module.exports = __webpack_public_path__ + "static/media/Spin.09c36991.png";